import getModelContextWindowTokens from '@/lib/model/getModelContextWindowTokens.js';

const toFiniteNonNegativeNumber = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string' && !value.trim()) {
    return null;
  }

  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0) {
    return null;
  }

  return parsed;
};

const normalizeContextWindowUsage = (contextWindowUsage = null) => {
  const payload = contextWindowUsage && typeof contextWindowUsage === 'object' ? contextWindowUsage : {};
  const model = String(payload?.model || '').trim() || null;
  const inputTokens = toFiniteNonNegativeNumber(payload?.inputTokens);
  const outputTokens = toFiniteNonNegativeNumber(payload?.outputTokens);
  const totalTokensRaw = toFiniteNonNegativeNumber(payload?.totalTokens ?? payload?.usedTokens);
  const totalTokens = totalTokensRaw ?? (inputTokens !== null && outputTokens !== null ? inputTokens + outputTokens : null);
  const realInputTokens = toFiniteNonNegativeNumber(payload?.realInputTokens);
  const percentUsedRaw = Number(payload?.percentUsed);
  const remainingTokensRaw = toFiniteNonNegativeNumber(payload?.remainingTokens);
  const hasUsageSignal = inputTokens !== null || outputTokens !== null || totalTokens !== null || realInputTokens !== null || remainingTokensRaw !== null || (Number.isFinite(percentUsedRaw) && percentUsedRaw >= 0);

  if (!hasUsageSignal) {
    return null;
  }

  const contextWindowTokensRaw = toFiniteNonNegativeNumber(payload?.contextWindowTokens);
  const contextWindowTokens = contextWindowTokensRaw !== null && contextWindowTokensRaw > 0 ? contextWindowTokensRaw : getModelContextWindowTokens(model);
  const autoCompactLimitTokensRaw = toFiniteNonNegativeNumber(payload?.autoCompactLimitTokens);
  const autoCompactLimitTokens = autoCompactLimitTokensRaw !== null && autoCompactLimitTokensRaw > 0 ? autoCompactLimitTokensRaw : null;
  const meterCeilingTokens = autoCompactLimitTokens ?? contextWindowTokens;
  // Meter numerator prefers real input tokens (the axis the provider's
  // compaction trigger compares against); legacy rows without the field fall
  // back to `totalTokens`.
  const meterNumeratorTokens = realInputTokens ?? totalTokens;
  const remainingTokens = remainingTokensRaw ?? (meterCeilingTokens !== null && meterNumeratorTokens !== null ? Math.max(meterCeilingTokens - meterNumeratorTokens, 0) : null);
  const percentUsed = Number.isFinite(percentUsedRaw) && percentUsedRaw >= 0 ? Math.max(0, Math.round(percentUsedRaw)) : meterCeilingTokens !== null && meterCeilingTokens > 0 && meterNumeratorTokens !== null ? Math.max(0, Math.round((meterNumeratorTokens / meterCeilingTokens) * 100)) : null;

  return {
    model,
    inputTokens,
    outputTokens,
    totalTokens,
    realInputTokens,
    contextWindowTokens,
    autoCompactLimitTokens,
    remainingTokens,
    percentUsed
  };
};

export default normalizeContextWindowUsage;
